/**
 * @fileoverview Shared geometry for the 3×3 app / home grid icon.
 * @purpose One source of truth for `AppsAsCardsIcon` and `HomeGridIcon` layout.
 * @ownership Core package
 */

/** Top-left (x, y) of each cell in the 24×24 viewBox (5×5 cells, 2px gap). */
export const HOME_GRID_CELL_TOP_LEFT: ReadonlyArray<readonly [number, number]> = [
  [2.5, 2.5],
  [9.5, 2.5],
  [16.5, 2.5],
  [2.5, 9.5],
  [9.5, 9.5],
  [16.5, 9.5],
  [2.5, 16.5],
  [9.5, 16.5],
  [16.5, 16.5],
] as const;

export const HOME_GRID_CELL_SIZE = 5;
export const HOME_GRID_CELL_RX = 1.25;
